import React, { Component } from 'react'
import {Popup} from 'semantic-ui-react'
import _ from 'lodash';


export default class GoxTableData extends Component {

  constructor(props) {
   super(props);
   this.state = {
     column: null,
     data: this.props.reportData,
     order: true,
   }
  }

  componentWillUpdate(nextProps, nextState) {

    if(nextProps.reportData.length && this.state.data.length && (nextProps.reportData.length !== this.state.data.length || Object.keys(nextProps.reportData[0]).length !== Object.keys(this.state.data[0]).length)) {
      let updateData = nextProps.reportData;

      if(this.state.column) {
        updateData = _.sortBy(updateData, [this.state.column])
        if(!this.state.order) {
          updateData.reverse();
        }
      }
      this.setState({
        data: updateData
      });
    }
  }
  handleSort = clickedColumn => () => {
    const { column, data, order } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        order: true,
      })

      return
    }

    this.setState({
      data: data.reverse(),
      order: !order
    })
  }

  trimString = (str, len, addDots) => {
    return (
      (str && str.length > len) ?
      (addDots !== false ?
        str.substring(0, len - 3) :
        str.substring(0, len - 3) + '...') :
      str);
  }

  getHeader = (detailsModal, eventClick) => {
    const { column, order } = this.state;
    const direction = order ? 'down' : 'up';
    if(detailsModal === 'report') {
      return (
        <tr>
          <th className={`cursorPointer ${column === 'patientId' ? 'active': ''}`} onClick={this.handleSort('patientId')}>
            Patient#
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'price' ? 'active': ''}`} onClick={this.handleSort('price')}>
            bCare
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          {eventClick === 'month' &&  <th className={`cursorPointer ${column === 'dateOfService' ? 'active': ''}`} onClick={this.handleSort('dateOfService')}>
            Date Of Service
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>}
        </tr>
      );
    } else {
      return (
        <tr>
          {
            this.props.page === 'bGoal' ?
              <th className={`cursorPointer ${column === 'drName' ? 'active': ''}`} onClick={this.handleSort('drName')}>
                  <div>
                DrName
                <i className={`sort amount ${direction} icon ml-05`}></i>
                  </div>
              </th>
            :
              <th className={`cursorPointer ${column === 'practice' ? 'active': ''}`} onClick={this.handleSort('practice')}>
                  <div>
                Practice
                <i className={`sort amount ${direction} icon ml-05`}></i>
                  </div>
              </th>
          }
          <th className={`cursorPointer ${column === 'patientId' ? 'active': ''}`} onClick={this.handleSort('patientId')}>
            Patient#
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          {eventClick === 'month' &&  <th className={`cursorPointer ${column === 'dateOfService' ? 'active': ''}`} onClick={this.handleSort('dateOfService')}>
            Date Of Service
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>}
          <th className={`cursorPointer ${column === 'procCode' ? 'active': ''}`} onClick={this.handleSort('procCode')}>
            Proc Code
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'bCare' ? 'active': ''}`} onClick={this.handleSort('price')}>
            bCare
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          
          <th className={`cursorPointer ${column === 'price' ? 'active': ''}`} onClick={this.handleSort('price')}>
            ProcFee
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'writeOff' ? 'active': ''}`} onClick={this.handleSort('price')}>
            WriteOff
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
          <th className={`cursorPointer ${column === 'bCare' ? 'active': ''}`} onClick={this.handleSort('price')}>
            X-deductions
            <i className={`sort amount ${direction} icon ml-05`}></i>
          </th>
        </tr>
      );
    }
  }

  getTableRows = (detailsModal, reportData, eventClick, mtdBillable, productionPrice) => {
    const { data } = this.state;
    const {getPracticeName} = this.props;
    let returnArray = [];
    let totalPrice = 0;
    let totalbCare = 0;
    let totalWriteOff = 0;
    let uniKey = 0;
    if(detailsModal === 'report') {
    if(Object.keys(data).length) {
           data.forEach( (item) => {
             totalPrice += item.price;
             uniKey++;
              returnArray.push(
                <tr key={uniKey}>
                  <td className="primaryColor cursorPointer"><span onClick={() => this.props.openFamilyView(item.patientId, item.practice, item.practiceName)}>{ item.patientId }</span></td>
                  { eventClick === 'month' && <td>{ item.dateOfService }</td> }
                  <td>${ item.bCare.toFixed(2) }</td>
                  <td>${ item.procFee.toFixed(2) }</td>
                  <td>${ item.writeOff.toFixed(2) }</td>
                </tr>
              );
         });

         returnArray.push(
           <tr key={"total"}>
             <td colSpan="2"><strong>Total</strong></td>
               <td colSpan="2"><strong>${ totalPrice.toFixed(2) }</strong></td>
           </tr>
         );
         return <tbody>{returnArray}</tbody>
      } else {
        return (
          <tbody>
            <tr>
              <td colSpan="4">No Record Found</td>
            </tr>
          </tbody>
        );
      }
    } else {
      if(Object.keys(data).length) {
          data.forEach( (item) => {
            totalPrice += item.procFee;
            totalbCare += item.bCare;
            totalWriteOff += item.writeOff;
            uniKey++;
            returnArray.push(
              <tr key={uniKey}>
                <td>{getPracticeName(item.practice)}</td>
                <td className="primaryColor cursorPointer"><span onClick={() => this.props.openFamilyView(item.patientId, item.practice)}>{ item.patientId }</span></td>
                { eventClick === 'month' && <td>{ item.dateOfService }</td> }
                <td><Popup trigger={<div>{this.trimString(item.procCode, 15, false)}</div>} content={item.procCode} /></td>
                <td>${ item.bCare.toFixed(2) }</td>
                <td>${ item.procFee.toFixed(2) }</td>
                <td>${ item.writeOff.toFixed(2) }</td>
                <td>${ item.bCare.toFixed(2) }</td>
              </tr>
            );
         });
         returnArray.push(
           <tr key={"total"}>
             <td colSpan="4"><strong>Total</strong></td>
                <td><strong>${totalbCare.toFixed(2)}</strong></td>
                <td><strong>${totalPrice.toFixed(2)}</strong></td>
                <td><strong>${totalWriteOff.toFixed(2)}</strong></td>
                <td><strong>${totalbCare.toFixed(2)}</strong></td>
           </tr>
         );
         return <tbody>{returnArray}</tbody>
      } else {
        return (
          <tbody>
            <tr>
              <td colSpan="8">No Record Found</td>
            </tr>
          </tbody>
        );
      }
    }
  }

  render() {
    const { reportData, detailsModal, eventClick, mtdBillable, productionPrice } = this.props;
    return(
      <div>
        <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed">
        <thead>
          { this.getHeader(detailsModal, eventClick) }
        </thead>
        { reportData && this.getTableRows(detailsModal, reportData, eventClick, mtdBillable, productionPrice) }
      </table>

      </div>
    );
  }
}
